<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Ajustes de Inventario" />

    <div class="flex-grow-1 overflow-auto px-3 pb-3">

      <!-- Filtros + botón nuevo -->
      <div class="card mb-3">
        <div class="card-body py-3">
          <div class="row g-2 align-items-end">
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Desde</label>
              <input v-model="filtros.f1" @change="cargar" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Hasta</label>
              <input v-model="filtros.f2" @change="cargar" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Almacén</label>
              <select v-model="filtros.idalmacen" @change="cargar" class="form-select form-select-sm">
                <option value="">Ambos</option>
                <option value="1">939</option>
                <option value="15">1179</option>
              </select>
            </div>
            <div class="col-6 col-md-2">
              <label class="form-label mb-1 small fw-semibold">Tipo</label>
              <select v-model="filtros.signo" @change="cargar" class="form-select form-select-sm">
                <option value="">Todos</option>
                <option value="+">Entrada (+)</option>
                <option value="-">Salida (−)</option>
              </select>
            </div>
            <div class="col-6 col-md-2">
              <button @click="limpiar" class="btn btn-sm btn-outline-secondary w-100">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="col-6 col-md-2">
              <button @click="abrirNuevo" class="btn btn-sm btn-primary w-100">
                <i class="fa fa-plus me-1"></i> Nuevo ajuste
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla -->
      <div class="card">
        <div class="card-body p-0">
          <div v-if="cargando" class="text-center py-5 text-muted">
            <div class="spinner-border spinner-border-sm me-2"></div>Cargando…
          </div>
          <div v-else-if="!ajustes.length" class="text-center py-5 text-muted">
            No se encontraron ajustes con los filtros aplicados.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-hover table-sm mb-0">
              <thead class="table-light">
                <tr>
                  <th class="ps-3">Documento</th>
                  <th>Almacén</th>
                  <th>Fecha</th>
                  <th class="text-center">Tipo</th>
                  <th class="text-center">Items</th>
                  <th>Observación</th>
                  <th class="text-center">Ver</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in ajustes" :key="a.idreg">
                  <td class="ps-3 font-monospace small">{{ a.serie }}-{{ a.numero }}</td>
                  <td class="small">{{ a.almacen }}</td>
                  <td class="small">{{ fmtFecha(a.fecha_emision) }}</td>
                  <td class="text-center">
                    <span :class="a.signo==='+' ? 'badge bg-success-subtle text-success' : 'badge bg-danger-subtle text-danger'">
                      {{ a.signo==='+' ? '▲ Entrada' : '▼ Salida' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="badge bg-secondary-subtle text-secondary">{{ a.num_items || '—' }}</span>
                  </td>
                  <td class="small text-muted">{{ a.observacion || '—' }}</td>
                  <td class="text-center">
                    <button @click="verDetalle(a)" class="btn btn-xs btn-outline-primary">
                      <i class="fa fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="totalPags > 1" class="d-flex justify-content-between align-items-center px-3 py-2 border-top">
            <small class="text-muted">{{ total }} ajustes</small>
            <div class="d-flex gap-1">
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina<=1" @click="paginar(pagina-1)">‹</button>
              <span class="btn btn-sm btn-secondary disabled">{{ pagina }} / {{ totalPags }}</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina>=totalPags" @click="paginar(pagina+1)">›</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>

  <!-- ─── Modal detalle ajuste ──────────────────────────────────── -->
  <div v-if="detalleModal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1055" @click.self="detalleModal=null">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header py-2">
          <div>
            <h6 class="modal-title fw-bold mb-0">Ajuste {{ detalleModal.serie }}-{{ detalleModal.numero }}</h6>
            <small class="text-muted">{{ detalleModal.almacen }} · {{ fmtFecha(detalleModal.fecha_emision) }}</small>
          </div>
          <button class="btn-close btn-sm" @click="detalleModal=null"></button>
        </div>
        <div class="modal-body py-2">
          <div v-if="cargandoDetalle" class="text-center py-3"><div class="spinner-border spinner-border-sm"></div></div>
          <div v-else>
            <div class="d-flex gap-3 mb-3 small">
              <span>
                Tipo:
                <span :class="detalleModal.signo==='+' ? 'badge bg-success-subtle text-success' : 'badge bg-danger-subtle text-danger'">
                  {{ detalleModal.signo==='+' ? '▲ Entrada' : '▼ Salida' }}
                </span>
              </span>
              <span v-if="detalleModal.observacion" class="text-muted">{{ detalleModal.observacion }}</span>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Código</th>
                    <th>Producto</th>
                    <th class="text-center">Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in detalleModal.detalles" :key="d.iddet">
                    <td class="font-monospace small">{{ d.codbarras || d.codigo_proveedor || d.idpres }}</td>
                    <td class="small">{{ d.producto || d.presentacion }}</td>
                    <td class="text-center fw-semibold">{{ d.cantidad }}</td>
                  </tr>
                  <tr v-if="!detalleModal.detalles?.length">
                    <td colspan="3" class="text-center text-muted py-3">Sin detalle</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Modal nuevo ajuste ────────────────────────────────────── -->
  <div v-if="nuevoModal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1055" @click.self="cerrarNuevo">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h6 class="modal-title fw-bold">Nuevo Ajuste de Inventario</h6>
          <button class="btn-close btn-sm" @click="cerrarNuevo"></button>
        </div>
        <div class="modal-body">

          <!-- Cabecera -->
          <div class="row g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label small fw-semibold">Almacén <span class="text-danger">*</span></label>
              <select v-model="nuevoAjuste.idalmacen" class="form-select form-select-sm">
                <option value="">Seleccionar…</option>
                <option :value="1">939 — A.LAPOINT 939</option>
                <option :value="15">1179 — A.LAPOINT 1179</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label small fw-semibold">Tipo <span class="text-danger">*</span></label>
              <select v-model="nuevoAjuste.signo" class="form-select form-select-sm">
                <option value="+">▲ Entrada — suma stock</option>
                <option value="-">▼ Salida — resta stock</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label small fw-semibold">Fecha</label>
              <input v-model="nuevoAjuste.fecha" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-md-4">
              <label class="form-label small fw-semibold">Motivo / Observación</label>
              <input v-model="nuevoAjuste.observacion" type="text" class="form-control form-control-sm" placeholder="Ej: devolución proveedor, merma…" />
            </div>
          </div>

          <!-- Buscador de productos -->
          <div class="card bg-light mb-2">
            <div class="card-body py-2">
              <div class="d-flex gap-2 align-items-center">
                <input v-model="busqProd" @input="buscarProductos" type="text"
                  class="form-control form-control-sm" style="max-width:320px"
                  placeholder="Buscar producto por nombre o código…" />
              </div>
              <div v-if="prodResultados.length" class="mt-2 border rounded bg-white" style="max-height:200px;overflow-y:auto">
                <table class="table table-sm table-hover mb-0">
                  <thead class="table-light sticky-top"><tr>
                    <th>Código</th><th>Producto</th>
                    <th class="text-center">Stock 939</th>
                    <th class="text-center">Stock 1179</th>
                    <th></th>
                  </tr></thead>
                  <tbody>
                    <tr v-for="p in prodResultados" :key="p.idpres">
                      <td class="font-monospace small">{{ p.codigo_prov || p.codbarras }}</td>
                      <td class="small">{{ p.nombre }}</td>
                      <td class="text-center small">{{ p.stock_t1 }}</td>
                      <td class="text-center small">{{ p.stock_t2 }}</td>
                      <td class="text-center">
                        <button @click="agregarItem(p)" class="btn btn-xs btn-outline-primary">+ Agregar</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Líneas -->
          <div v-if="nuevoAjuste.items.length" class="table-responsive">
            <table class="table table-sm table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Producto</th>
                  <th class="text-center" style="width:130px">Cantidad <span class="text-danger">*</span></th>
                  <th class="text-center" style="width:60px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in nuevoAjuste.items" :key="item.idpres">
                  <td class="small">
                    <div class="fw-semibold">{{ item.nombre }}</div>
                    <div class="text-muted" style="font-size:.75rem">{{ item.codbarras }}</div>
                  </td>
                  <td class="text-center">
                    <input v-model.number="item.cantidad" type="number" min="1"
                      class="form-control form-control-sm text-center" style="width:90px;margin:0 auto" />
                  </td>
                  <td class="text-center">
                    <button @click="nuevoAjuste.items.splice(i,1)" class="btn btn-xs btn-outline-danger">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-end mt-1">
              <small class="text-muted">{{ nuevoAjuste.items.length }} producto(s)</small>
            </div>
          </div>
          <div v-else class="text-center py-3 text-muted small">Busca y agrega productos arriba.</div>

          <div v-if="errorNuevo" class="alert alert-danger mt-2 py-2 small">{{ errorNuevo }}</div>
        </div>
        <div class="modal-footer py-2">
          <small class="text-muted me-auto">El ajuste se aplica inmediatamente al stock.</small>
          <button class="btn btn-sm btn-outline-secondary" @click="cerrarNuevo">Cancelar</button>
          <button class="btn btn-sm btn-primary" :disabled="guardando" @click="guardarAjuste">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            Aplicar ajuste
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader    from '../../components/Layouts/MainHeader.vue';
import MainSidebar   from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import MainFooter    from '../../components/Layouts/MainFooter.vue';
import api from '../../services/api';

const HOY = new Date().toISOString().slice(0,10);

export default {
  name: 'AjustesPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu, MainFooter },
  data() {
    return {
      ajustes: [], total: 0, pagina: 1, pageSize: 30, cargando: false,
      filtros: { f1: '', f2: '', idalmacen: '', signo: '' },
      debounceTimer: null,

      detalleModal: null, cargandoDetalle: false,

      nuevoModal: false,
      nuevoAjuste: { idalmacen: '', signo: '+', fecha: HOY, observacion: '', items: [] },
      busqProd: '', prodResultados: [], busqTimer: null,
      guardando: false, errorNuevo: '',
    };
  },
  computed: {
    totalPags() { return Math.ceil(this.total / this.pageSize); },
  },
  mounted() { this.cargar(); },
  methods: {
    async cargar() {
      this.cargando = true;
      try {
        const p = { page: this.pagina, limit: this.pageSize };
        if (this.filtros.f1)        p.f1        = this.filtros.f1;
        if (this.filtros.f2)        p.f2        = this.filtros.f2;
        if (this.filtros.idalmacen) p.idalmacen = this.filtros.idalmacen;
        if (this.filtros.signo)     p.signo     = this.filtros.signo;
        const r = await api.get('/inventario/ajustes', { params: p });
        const d = r.data?.data ?? r.data;
        this.ajustes = Array.isArray(d) ? d : (d?.data ?? []);
        this.total = r.data?.pagination?.total ?? d?.total ?? this.ajustes.length;
      } catch(e) { console.error(e); this.ajustes = []; }
      finally { this.cargando = false; }
    },
    paginar(p) { this.pagina=p; this.cargar(); },
    limpiar() { this.filtros={f1:'',f2:'',idalmacen:'',signo:''}; this.pagina=1; this.cargar(); },

    async verDetalle(a) {
      this.detalleModal = { ...a, detalles: [] };
      this.cargandoDetalle = true;
      try {
        const r = await api.get(`/inventario/ajustes/${a.idreg}`);
        const d = r.data?.data ?? r.data;
        this.detalleModal = { ...d, detalles: d.detalles || d.items || [] };
      } catch(e) { console.error(e); }
      finally { this.cargandoDetalle = false; }
    },

    abrirNuevo() {
      this.nuevoAjuste = { idalmacen:'', signo:'+', fecha:HOY, observacion:'', items:[] };
      this.busqProd=''; this.prodResultados=[]; this.errorNuevo='';
      this.nuevoModal = true;
    },
    cerrarNuevo() { this.nuevoModal=false; this.busqProd=''; this.prodResultados=[]; },
    buscarProductos() {
      clearTimeout(this.busqTimer);
      if (!this.busqProd.trim()) { this.prodResultados=[]; return; }
      this.busqTimer = setTimeout(async () => {
        try {
          const r = await api.get('/productos', { params:{ q:this.busqProd, limit:20, publicado:false } });
          const d = r.data?.data ?? r.data;
          this.prodResultados = Array.isArray(d) ? d : (d?.data ?? []);
        } catch(e) { this.prodResultados=[]; }
      }, 350);
    },
    agregarItem(p) {
      if (this.nuevoAjuste.items.find(i => i.idpres===p.idpres)) return;
      this.nuevoAjuste.items.push({ idpres:p.idpres, nombre:p.nombre||p.pres_nombre, codbarras:p.codbarras, cantidad:1 });
    },
    async guardarAjuste() {
      this.errorNuevo = '';
      if (!this.nuevoAjuste.idalmacen) { this.errorNuevo='Selecciona un almacén.'; return; }
      if (!this.nuevoAjuste.items.length) { this.errorNuevo='Agrega al menos un producto.'; return; }
      const invalidos = this.nuevoAjuste.items.filter(i => !i.cantidad || i.cantidad < 1);
      if (invalidos.length) { this.errorNuevo='Todas las cantidades deben ser ≥ 1.'; return; }
      this.guardando = true;
      try {
        await api.post('/inventario/ajustes', {
          idalmacen:   this.nuevoAjuste.idalmacen,
          signo:       this.nuevoAjuste.signo,
          fecha:       this.nuevoAjuste.fecha || undefined,
          observacion: this.nuevoAjuste.observacion || undefined,
          items: this.nuevoAjuste.items.map(i => ({ idpres:i.idpres, cantidad:i.cantidad })),
        });
        this.cerrarNuevo();
        this.cargar();
      } catch(e) {
        this.errorNuevo = e.response?.data?.error || e.response?.data?.message || 'Error al guardar';
      } finally { this.guardando = false; }
    },

    fmtFecha(f) {
      if (!f) return '—';
      return new Date(f).toLocaleDateString('es-PE', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
  },
};
</script>
